module.exports = __webpack_public_path__ + "static/media/administrators.41e59254.png";